import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { SortPartSerializer1fx0t5bmnpc8h as SortPartSerializer } from '../lightningdb/SortPartSerializer.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import {
  STRINGrrr0wq2m1c2f as STRING,
  CLASS3e32wwn6b97hz as CLASS,
  MAPtg3mcyan4256 as MAP,
  LIST2gzos3vzn3slg as LIST,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ConditionSerializer21tf3x2n3amih as ConditionSerializer,
  LazyRenamedSerialDescriptor35xsl6h8pjd6j as LazyRenamedSerialDescriptor,
} from '../lightningdb/ConditionSerialization.mjs';
import { ModificationSerializer3ubms8rrlijys as ModificationSerializer } from '../lightningdb/ModificationSerialization.mjs';
import { PartialSerializer6novagrzu32x as PartialSerializer } from './PartialSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { get_ClientModule2m5j3ywx3t162 as get_ClientModule } from './ClientModule.mjs';
import {
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
  ByteCompanionObject_instance9rvhjp0l184i as ByteCompanionObject_instance,
  ShortCompanionObject_instance3vq120mx8545m as ShortCompanionObject_instance,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  FloatCompanionObject_instance367t6x2s4xzmv as FloatCompanionObject_instance,
  DoubleCompanionObject_instance3q51gr7gsd0au as DoubleCompanionObject_instance,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  serializer3u3hsxnenk49x as serializer,
  serializer1r0h5yakm679b as serializer_0,
  serializer1tw0a8bv7lkga as serializer_1,
  serializer1hu9wv9at41ww as serializer_2,
  serializerodflzzf6s3fp as serializer_3,
  serializer3x9uckd1deom as serializer_4,
  serializer1wpgysz06u9ol as serializer_5,
  serializer345btyh1f2y1j as serializer_6,
  serializer1x79l67jvwntn as serializer_7,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_instance3skn40jhkoxyn as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  Companion_getInstance2e3h8n26rh23 as Companion_getInstance,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstance3eoge8j03l9b5 as Companion_getInstance_0 } from './SerializationRegistry.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KClassJs.mjs';
import { serializer23irjhw2jlmhr as serializer_8 } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KSerializerKeyClass;
function KSerializerKey() {
  if (KSerializerKeyClass === VOID) {
    class $ {
      static s4r(kSerializer, nullable) {
        var $this = createThis(this);
        $this.l3t_1 = kSerializer;
        $this.m3t_1 = nullable;
        var tmp = $this;
        var tmp0_safe_receiver = tryTypeParameterSerializers2($this.l3t_1);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(tmp0_safe_receiver.length);
          var inductionVariable = 0;
          var last = tmp0_safe_receiver.length;
          while (inductionVariable < last) {
            var item = tmp0_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$0 = KSerializerKey().p3t(item);
            destination.v(tmp$ret$0);
          }
          tmp_0 = destination;
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_1 = emptyList();
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp.n3t_1 = tmp_1;
        var tmp_2 = $this;
        var tmp0 = getKClassFromExpression($this.l3t_1).hashCode();
        // Inline function 'com.lightningkite.serialization.hashWith' call
        var other = hashCode($this.n3t_1);
        var tmp0_0 = imul(tmp0, 31) + other | 0;
        // Inline function 'com.lightningkite.serialization.hashWith' call
        var other_0 = $this.l3t_1.az().h10();
        var tmp0_1 = imul(tmp0_0, 31) + hashCode(other_0) | 0;
        // Inline function 'com.lightningkite.serialization.hashWith' call
        var other_1 = $this.m3t_1;
        tmp_2.o3t_1 = imul(tmp0_1, 31) + hashCode(other_1) | 0;
        return $this;
      }
      static p3t(kSerializer) {
        return this.s4r(kSerializer.az().l11() ? innerElement(kSerializer) : kSerializer, kSerializer.az().l11());
      }
      hashCode() {
        return this.o3t_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof KSerializerKey()) {
          tmp_2 = this.l3t_1.az().h10() === other.l3t_1.az().h10();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.m3t_1 === other.m3t_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = getKClassFromExpression(this.l3t_1).equals(getKClassFromExpression(other.l3t_1));
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(this.n3t_1, other.n3t_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      toString() {
        return toString(this.l3t_1);
      }
    }
    initMetadataForClass($, 'KSerializerKey');
    KSerializerKeyClass = $;
  }
  return KSerializerKeyClass;
}
function defer(serialName, kind, deferred) {
  return new (defer$1())(deferred, serialName, kind);
}
function innerElement(_this__u8e3s4) {
  var tmp;
  try {
    var tmp_0;
    if (_this__u8e3s4 instanceof WrappingSerializer()) {
      tmp_0 = innerElement(_this__u8e3s4.j3u());
    } else {
      _this__u8e3s4.pz(new (CheatingBastardDecoder())(0));
      throw Exception().ud(_this__u8e3s4.az().h10() + ' (' + toString(_this__u8e3s4) + ') did not have an inner element');
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof FoundSerializerSignal()) {
      var e = $p;
      tmp_1 = e.t4r_1;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function tryTypeParameterSerializers2(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.az().s11();
  var tmp;
  if (tmp0_subject instanceof LIST()) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [innerElement(_this__u8e3s4)];
  } else {
    if (tmp0_subject instanceof MAP()) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [innerElement2(_this__u8e3s4)];
    } else {
      if (tmp0_subject instanceof CLASS()) {
        var tmp1_elvis_lhs = tryTypeParameterSerializers(_this__u8e3s4);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : null;
          tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s1b();
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          var tmp4_safe_receiver = _this__u8e3s4 instanceof ConditionSerializer() ? _this__u8e3s4 : null;
          var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.r3t_1;
          var tmp_2;
          if (tmp5_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_2 = [tmp5_safe_receiver];
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var tmp6_elvis_lhs = tmp_1;
        var tmp_3;
        if (tmp6_elvis_lhs == null) {
          var tmp7_safe_receiver = _this__u8e3s4 instanceof ModificationSerializer() ? _this__u8e3s4 : null;
          var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.i44_1;
          var tmp_4;
          if (tmp8_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_4 = [tmp8_safe_receiver];
          }
          tmp_3 = tmp_4;
        } else {
          tmp_3 = tmp6_elvis_lhs;
        }
        var tmp9_elvis_lhs = tmp_3;
        var tmp_5;
        if (tmp9_elvis_lhs == null) {
          var tmp10_safe_receiver = _this__u8e3s4 instanceof PartialSerializer() ? _this__u8e3s4 : null;
          var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.j4r_1;
          var tmp_6;
          if (tmp11_safe_receiver == null) {
            tmp_6 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_6 = [tmp11_safe_receiver];
          }
          tmp_5 = tmp_6;
        } else {
          tmp_5 = tmp9_elvis_lhs;
        }
        tmp = tmp_5;
      } else {
        if (tmp0_subject instanceof STRING()) {
          var tmp12_safe_receiver = _this__u8e3s4 instanceof SortPartSerializer() ? _this__u8e3s4 : null;
          var tmp13_safe_receiver = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.w4a_1;
          var tmp_7;
          if (tmp13_safe_receiver == null) {
            tmp_7 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_7 = [tmp13_safe_receiver];
          }
          var tmp14_elvis_lhs = tmp_7;
          var tmp_8;
          if (tmp14_elvis_lhs == null) {
            var tmp15_safe_receiver = _this__u8e3s4 instanceof DataClassPathSerializer() ? _this__u8e3s4 : null;
            var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.z4a_1;
            var tmp_9;
            if (tmp16_safe_receiver == null) {
              tmp_9 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.arrayOf' call
              // Inline function 'kotlin.js.unsafeCast' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_9 = [tmp16_safe_receiver];
            }
            tmp_8 = tmp_9;
          } else {
            tmp_8 = tmp14_elvis_lhs;
          }
          tmp = tmp_8;
        } else {
          tmp = null;
        }
      }
    }
  }
  return tmp;
}
function WrappingSerializer$_get_to_$ref_wby5yt() {
  return (p0) => p0.j3u();
}
var WrappingSerializerClass;
function WrappingSerializer() {
  if (WrappingSerializerClass === VOID) {
    class $ {
      constructor(name) {
        this.g3u_1 = name;
        var tmp = this;
        tmp.h3u_1 = lazy(() => this.b3u());
        var tmp_0 = this;
        tmp_0.i3u_1 = new (LazyRenamedSerialDescriptor())(this.g3u_1, () => this.j3u().az());
      }
      j3u() {
        var tmp0 = this.h3u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('to', 1, tmp, WrappingSerializer$_get_to_$ref_wby5yt(), null);
        return tmp0.f2();
      }
      az() {
        return this.i3u_1;
      }
      pz(decoder) {
        return this.f3u(decoder.qz(this.j3u()));
      }
      k3u(encoder, value) {
        return encoder.nz(this.j3u(), this.d3u(value));
      }
      oz(encoder, value) {
        return this.k3u(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'WrappingSerializer', VOID, VOID, [KSerializer()]);
    WrappingSerializerClass = $;
  }
  return WrappingSerializerClass;
}
var CheatingBastardDecoderClass;
function CheatingBastardDecoder() {
  if (CheatingBastardDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(count, serializersModule) {
        count = count === VOID ? 0 : count;
        serializersModule = serializersModule === VOID ? get_ClientModule() : serializersModule;
        super();
        this.v4r_1 = count;
        this.w4r_1 = serializersModule;
        this.x4r_1 = 0;
      }
      mz() {
        return this.w4r_1;
      }
      b14(descriptor) {
        var _unary__edvuaz = this.x4r_1;
        this.x4r_1 = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.let' call
        return _unary__edvuaz >= descriptor.u11() ? -1 : _unary__edvuaz;
      }
      qz(deserializer) {
        if (this.v4r_1 === 0) {
          throw new (FoundSerializerSignal())(isInterface(deserializer, KSerializer()) ? deserializer : THROW_CCE());
        }
        this.v4r_1 = this.v4r_1 - 1 | 0;
        return FakerDecoder_getInstance().qz(deserializer);
      }
      z12() {
        throw new (FoundSerializerSignal())(serializer(BooleanCompanionObject_instance));
      }
      a13() {
        throw new (FoundSerializerSignal())(serializer_0(ByteCompanionObject_instance));
      }
      b13() {
        throw new (FoundSerializerSignal())(serializer_1(ShortCompanionObject_instance));
      }
      c13() {
        throw new (FoundSerializerSignal())(serializer_2(IntCompanionObject_instance));
      }
      d13() {
        throw new (FoundSerializerSignal())(serializer_3(Companion_instance));
      }
      e13() {
        throw new (FoundSerializerSignal())(serializer_4(FloatCompanionObject_instance));
      }
      f13() {
        throw new (FoundSerializerSignal())(serializer_5(DoubleCompanionObject_instance));
      }
      g13() {
        throw new (FoundSerializerSignal())(serializer_6(Companion_getInstance()));
      }
      h13() {
        throw new (FoundSerializerSignal())(serializer_7(StringCompanionObject_instance));
      }
      i13(enumDescriptor) {
        var tmp = Companion_getInstance_0().x3i_1;
        var tmp_0 = enumDescriptor.h10();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        throw new (FoundSerializerSignal())(ensureNotNull(tmp.y4r(tmp_0, tmp$ret$2)));
      }
    }
    initMetadataForClass($, 'CheatingBastardDecoder', CheatingBastardDecoder);
    CheatingBastardDecoderClass = $;
  }
  return CheatingBastardDecoderClass;
}
var FoundSerializerSignalClass;
function FoundSerializerSignal() {
  if (FoundSerializerSignalClass === VOID) {
    class $ extends Error {
      constructor(serializer) {
        super(null);
        setPropertiesToThrowableInstance(this);
        captureStack(this, this.u4r_1);
        this.t4r_1 = serializer;
      }
    }
    initMetadataForClass($, 'FoundSerializerSignal');
    FoundSerializerSignalClass = $;
  }
  return FoundSerializerSignalClass;
}
function innerElement2(_this__u8e3s4) {
  var tmp;
  try {
    var tmp_0;
    if (_this__u8e3s4 instanceof WrappingSerializer()) {
      tmp_0 = innerElement2(_this__u8e3s4.j3u());
    } else {
      _this__u8e3s4.pz(new (CheatingBastardDecoder())(1));
      throw Exception().ud(_this__u8e3s4.az().h10() + ' (' + toString(_this__u8e3s4) + ') did not have a second inner element');
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof FoundSerializerSignal()) {
      var e = $p;
      tmp_1 = e.t4r_1;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function tryTypeParameterSerializers(_this__u8e3s4) {
  var tmp0_safe_receiver = isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s1b();
}
var FakerDecoderClass;
function FakerDecoder() {
  if (FakerDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor() {
        FakerDecoder_instance = null;
        super();
        FakerDecoder_instance = this;
        this.z4r_1 = EmptySerializersModule();
      }
      mz() {
        return this.z4r_1;
      }
      z12() {
        return false;
      }
      a13() {
        return 0;
      }
      g13() {
        return _Char___init__impl__6a9atx(32);
      }
      f13() {
        return 0.0;
      }
      e13() {
        return 0.0;
      }
      c13() {
        return 0;
      }
      d13() {
        return 0n;
      }
      b13() {
        return 0;
      }
      h13() {
        return '';
      }
      i13(enumDescriptor) {
        return 0;
      }
      c14(descriptor) {
        return 0;
      }
      b14(descriptor) {
        return -1;
      }
      x12() {
        return true;
      }
    }
    initMetadataForObject($, 'FakerDecoder');
    FakerDecoderClass = $;
  }
  return FakerDecoderClass;
}
var FakerDecoder_instance;
function FakerDecoder_getInstance() {
  if (FakerDecoder_instance === VOID)
    new (FakerDecoder())();
  return FakerDecoder_instance;
}
function nullElement(_this__u8e3s4) {
  return _this__u8e3s4.az().l11() ? innerElement(_this__u8e3s4) : null;
}
function tryChildSerializers(_this__u8e3s4) {
  var tmp0_safe_receiver = isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r1b();
}
function mapValueElement(_this__u8e3s4) {
  return equals(_this__u8e3s4.az().s11(), MAP_getInstance()) ? innerElement2(_this__u8e3s4) : null;
}
function listElement(_this__u8e3s4) {
  return equals(_this__u8e3s4.az().s11(), LIST_getInstance()) ? innerElement(_this__u8e3s4) : null;
}
function serializerOrContextual(type) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.tf();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = serializerOrContextual(ensureNotNull(item.bt_1));
    destination.v(tmp$ret$0);
  }
  var args = destination;
  var tmp = type.sf();
  var kclass = (!(tmp == null) ? isInterface(tmp, KClass()) : false) ? tmp : THROW_CCE();
  var tmp_0;
  try {
    tmp_0 = serializer_8(EmptySerializersModule(), kclass, args, type.uf());
  } catch ($p) {
    var tmp_1;
    if ($p instanceof SerializationException()) {
      var e = $p;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$3 = copyToArray(args);
      // Inline function 'kotlin.let' call
      var it = ContextualSerializer().zy(kclass, null, tmp$ret$3);
      var tmp_2;
      if (type.uf()) {
        tmp_2 = get_nullable(isInterface(it, KSerializer()) ? it : THROW_CCE());
      } else {
        tmp_2 = it;
      }
      tmp_1 = tmp_2;
    } else {
      throw $p;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.a4s_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
  return tmp0.f2();
}
function defer$o$_get_original_$ref_3cje7k() {
  return (p0) => _get_original__l7ku1m(p0);
}
var defer$1Class;
function defer$1() {
  if (defer$1Class === VOID) {
    class $ {
      constructor($deferred, $serialName, $kind) {
        this.b4s_1 = $serialName;
        this.c4s_1 = $kind;
        this.a4s_1 = lazy($deferred);
      }
      h10() {
        return this.b4s_1;
      }
      s11() {
        return this.c4s_1;
      }
      u11() {
        return _get_original__l7ku1m(this).u11();
      }
      v11(index) {
        return _get_original__l7ku1m(this).v11(index);
      }
      w11(name) {
        return _get_original__l7ku1m(this).w11(name);
      }
      x11(index) {
        return _get_original__l7ku1m(this).x11(index);
      }
      y11(index) {
        return _get_original__l7ku1m(this).y11(index);
      }
      z11(index) {
        return _get_original__l7ku1m(this).z11(index);
      }
      bz() {
        return _get_original__l7ku1m(this).bz();
      }
      t11() {
        return _get_original__l7ku1m(this).t11();
      }
      l11() {
        return _get_original__l7ku1m(this).l11();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [SerialDescriptor()]);
    defer$1Class = $;
  }
  return defer$1Class;
}
//region block: exports
export {
  KSerializerKey as KSerializerKeys3rcxhak3gf5,
  WrappingSerializer as WrappingSerializer3cq24ex5vrdbg,
  defer as deferua88pnmsrho6,
  innerElement2 as innerElement27ac4km1wtjgu,
  innerElement as innerElement3bfmmmhd9fksr,
  listElement as listElement2fr0t0e999y76,
  mapValueElement as mapValueElement74u0ojsosa2t,
  nullElement as nullElementzitp7se36veh,
  serializerOrContextual as serializerOrContextual1whp5jyfp32aq,
  tryChildSerializers as tryChildSerializers3gpe7qns3v7j,
  tryTypeParameterSerializers as tryTypeParameterSerializers1jrcyh9alxuh0,
};
//endregion

//# sourceMappingURL=SerializationHelpers.mjs.map
